import { render, staticRenderFns } from "./CommonPageComponent.vue?vue&type=template&id=95989c0e"
import script from "./CommonPageComponent.vue?vue&type=script&lang=js"
export * from "./CommonPageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports